  (function() {
    function initProductDataTabs(root) {
      if (!root || root.dataset.tabsReady === 'true') return;
      root.dataset.tabsReady = 'true';

      var triggers = root.querySelectorAll('[data-tab-trigger]');
      var panels = root.querySelectorAll('[data-tab-panel]');

      function hydrateProductDataPanel(panel) {
        if (!panel || !panel.hasAttribute('data-product-data-placeholder')) {
          return panel;
        }

        var template = panel.querySelector('template[data-product-data-panel-template]');
        if (!template) return panel;

        var fragment = template.content.cloneNode(true);
        var hydratedPanel = fragment.querySelector('[data-tab-panel]');

        if (!hydratedPanel) return panel;

        panel.parentNode.replaceChild(hydratedPanel, panel);

        return hydratedPanel;
      }

      function activateTab(targetId) {
        triggers.forEach(function(trigger) {
          var isActive = trigger.getAttribute('data-tab-target') === targetId;
          trigger.classList.toggle('is-active', isActive);
          trigger.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        var targetPanel = document.getElementById(targetId);

        if (targetPanel && root.contains(targetPanel)) {
          targetPanel = hydrateProductDataPanel(targetPanel);
        }

        panels = root.querySelectorAll('[data-tab-panel]');

        panels.forEach(function(panel) {
          var isActive = panel.id === targetId;
          panel.classList.toggle('is-active', isActive);
          panel.hidden = !isActive;
        });

        return targetPanel;
      }

      triggers.forEach(function(trigger) {
        trigger.addEventListener('click', function() {
          var targetPanel = activateTab(trigger.getAttribute('data-tab-target'));
          decorateProductDataTooltips(targetPanel);
        });
      });

      function escapeHtml(str) {
        return String(str || '')
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;')
          .replace(/"/g, '&quot;')
          .replace(/'/g, '&#039;');
      }

      function normalizeTooltipKey(value) {
        if (typeof window.normalizeCompareTooltipKey === 'function') {
          return window.normalizeCompareTooltipKey(value);
        }

        return String(value || '')
          .normalize('NFC')
          .trim()
          .toLowerCase()
          .replace(/[–—]/g, '-')
          .replace(/\u00a0/g, ' ')
          .replace(/\s+/g, ' ');
      }

      var tooltipGroupBySection = {
        'Provedení': 'provedeni',
        'Provedení a design': 'provedeni_a_design',
        'Typ / označení': 'konstrukce',
        'Odstřeďování': 'odstredovani',
        'Design': 'design',
        'Čisticí výkon': 'cistici_vykon',
        'Čištění': 'cisteni',
        'Šetrná péče o prádlo': 'setrna_pece_o_pradlo',
        'Komfort při obsluze': 'komfort_pri_obsluze',
        'Komfort při údržbě': 'komfort_pri_udrzbe',
        'Mobilita': 'mobilita',
        'Filtrační systém': 'filtracni_system',
        'Hospodárnost a udržitelnost': 'hospodarnost_a_udrzitelnost',
        'Chladicí zóna': 'chladici_zona',
        'Mrazicí zóna': 'mrazici_zona',
        'Programy praní': 'programy_prani',
        'Programy sušení': 'programy_suseni',
        'Výsledek sušení': 'vysledek_suseni',
        'Extra funkce praní': 'extra_funkce',
        'Extra funkce': 'extra_funkce',
        'Bezpečnost': 'bezpecnost',
        'Technické údaje': 'technicke_udaje',
        'Dodávané příslušenství': 'dodavane_prislusenstvi',
        'Dostupné jazyky displeje': 'komfort_pri_obsluze',
        'Uživatelské výhody': 'uzivatelske_vyhody',
        'Parní technologie / přívod vody': 'parni_technologie_privod_vody',
        'Provozní způsoby': 'provozni_zpusoby',
        'Odtah': 'odtah',
        'Osvětlení': 'osvetleni',
        'Ventilátor': 'ventilator',
            'Montážní pokyny': 'montazni_pokyny',
        'Použití': 'pouziti',
        'Výkonové údaje': 'vykonove_udaje',
        'Řídicí jednotka': 'ridici_jednotka',
        'Standardní elektrické připojení': 'standardni_elektricke_pripojeni',
        'Možná varianta napětí 1': 'mozna_varianta_napeti_1',
        'Přípojka přívodu a odvodu vody': 'pripojka_privodu_a_odvodu_vody',
        'Rozměry a hmotnost': 'rozmery_a_hmotnost',
        'Emisní hodnoty': 'emisni_hodnoty',
        'Programy mytí': 'programy_myti',
        'Košové uspořádání': 'kosove_usporadani',
        'Možnosti připojení': 'moznosti_pripojeni',
        'Normy, zkušební a identifikační označení': 'normy_zkusebni_a_identifikacni_oznaceni'
      };

      function findTooltip(labelText, groupCode) {
        var tips = window.compareTooltips || {};
        var normalizedLabel = normalizeTooltipKey(labelText);
        var normalizedGroup = normalizeTooltipKey(groupCode);

        if (normalizedGroup && normalizedLabel) {
          var grouped = tips['group_value::' + normalizedGroup + '::' + normalizedLabel];
          if (grouped) return grouped;
        }

        if (normalizedLabel) {
          var plain = tips['value::' + normalizedLabel];
          if (plain) return plain;
        }

        return '';
      }

      function decorateProductDataTooltips(scope) {
        if (!scope) return;

        var rows = scope.querySelectorAll('.product-data-row');

        rows.forEach(function(row) {
          var label = row.querySelector('.product-data-row__label');
          if (!label) return;
          if (label.dataset.tooltipReady === 'true') return;

          var labelText = String(label.textContent || '').trim();
          if (!labelText) return;

          var accordionItem = row.closest('.product-data-accordion__item');
          var summary = accordionItem ? accordionItem.querySelector('.product-data-accordion__summary') : null;
          var summaryText = summary ? String(summary.textContent || '').trim() : '';
          var groupCode = tooltipGroupBySection[summaryText] || '';
          var tooltip = findTooltip(labelText, groupCode);

          if (!tooltip) return;

          label.innerHTML =
            '<span class="product-data-row__label-text">' + escapeHtml(labelText) + '</span>' +
            '<span class="product-data-tooltip">' +
              '<button type="button" class="product-data-tooltip-trigger" aria-label="Více informací: ' + escapeHtml(labelText) + '">i</button>' +
              '<span class="product-data-tooltip-content" role="tooltip">' + escapeHtml(tooltip) + '</span>' +
            '</span>';

          label.dataset.tooltipReady = 'true';
        });
      }

      function enhanceProductDescription() {
        var description = root.querySelector('[data-product-description-layout]');
        if (!description || description.dataset.layoutReady === 'true') return;
    
        if (description.querySelector('.miele-premium-content')) {
          description.dataset.layoutReady = 'true';
          return;
        }

        var children = Array.prototype.slice.call(description.children).filter(function(child) {
          return child.tagName && !child.matches('script, style');
        });

        if (!children.length) return;

        var fragment = document.createDocumentFragment();
        var intro = document.createElement('div');
        intro.className = 'pdesc-hero';

        var currentSection = null;
        var hasSectionStarted = false;

        function createSection() {
          var section = document.createElement('section');
          section.className = 'pdesc-section';
          fragment.appendChild(section);
          currentSection = section;
          return section;
        }

        children.forEach(function(child) {
          var tag = child.tagName ? child.tagName.toLowerCase() : '';

          if (tag === 'h1') {
            child.classList.add('pdesc-hero-title');
            intro.appendChild(child);
            return;
          }

          if (tag === 'h2') {
            var section = createSection();
            child.classList.add('pdesc-section-title');
            section.appendChild(child);
            hasSectionStarted = true;
            return;
          }

          if (!hasSectionStarted && (tag === 'p' || tag === 'ul' || tag === 'ol')) {
            if (tag === 'p') {
              child.classList.add('pdesc-hero-text');
            } else {
              child.classList.add('pdesc-hero-list');
            }

            intro.appendChild(child);
            return;
          }

          if (!currentSection) {
            createSection();
          }

          currentSection.appendChild(child);
        });

        description.innerHTML = '';

        if (intro.children.length) {
          description.appendChild(intro);
        }

        description.appendChild(fragment);
        description.dataset.layoutReady = 'true';
      }

  function initProductDataTabsEnhancements() {
    function runEnhancements() {
      enhanceProductDescription();

      var activePanel = root.querySelector('[data-tab-panel].is-active');

      if (activePanel) {
        decorateProductDataTooltips(activePanel);
      }
    }

    if (!('IntersectionObserver' in window)) {
      runEnhancements();
      return;
    }

    var observer = new IntersectionObserver(function(entries) {
      var isNearViewport = entries.some(function(entry) {
        return entry.isIntersecting;
      });

      if (!isNearViewport) return;

      observer.disconnect();

      if ('requestIdleCallback' in window) {
        requestIdleCallback(runEnhancements, { timeout: 1000 });
      } else {
        setTimeout(runEnhancements, 0);
      }
}, {
  rootMargin: '300px 0px'
});

observer.observe(root);
  }

  initProductDataTabsEnhancements();
}

function initAllProductDataTabs() {
  var roots = document.querySelectorAll('.product-data-tabs');

  roots.forEach(function(root) {
    initProductDataTabs(root);
  });
}

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllProductDataTabs);
    } else {
      initAllProductDataTabs();
    }
  })();